<template>
  <div class='citySearch'>
    <div class="input-container" @click="show=!show">
      <img src="@/assets/serve/factory/loaction.png" alt="" class="location-icon">
      <input type="text" readonly autocomplete="off" v-model="inputValue" placeholder="请选择所在地区">
      <img src="@/assets/serve/factory/down.png" alt="" :class="['down-icon', {'active': show}]">
    </div>
    <transition name="el-zoom-in-top">
      <div class="modal" v-show="show">
        <div class="title">
          <span :class="{'active': form.province && !form.city}">省</span>
          <span :class="{'active': form.city}">市</span>
        </div>
        <div class="content">
          <ul>
            <li :class="{'active' : form.province === ''}" @click="selectAll('province')">所有</li>
            <li v-for="(item,index) in provinceList" :key="'province' + index" @click="selectArea('province', item)" :class="{'active' : form.province === item.province}">
              {{item.province}}
            </li>
          </ul>
          <ul>
            <li v-if="cityList.length > 0" :class="{'active' : form.city === ''}" @click="selectAll('city')">所有</li>
            <li v-for="(item,index) in cityList" :key="'city' + index" @click="selectArea('city', item)"  :class="{'active' : form.city === item.city}">
              {{item.city}}
            </li>
          </ul>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { AreaList } from '@/api/store'
export default {
  name: 'CitySearch',
  components:{ 
  },
  props: {
    type: {
       type: Number,
       default: 0
    }
  },
  data() {
    return {
      show: false,
      inputValue: '',
      provinceList: [],
      cityList: [],
      form: {
        province: '',
        city: ''
      }
    }
  },
  computed:{ },
  watch:{ },
  created() {
    this.queryMap()
  },
  mounted() {
    this.inputValue = `${this.form.province}${this.form.city}`
  },
  methods: {
    queryMap() {
      AreaList({
        data_type: this.type
      }).then(res => {
        this.provinceList = res.data
      })
    },
    selectArea(value, data) {
      this.form[value] = data[value]
      if (value == 'province') {
        this.form.city = ''
        this.cityList = data.children
      } else if (value == 'city') {
        this.show = false
        this.$emit('areaForm', this.form)
      }
      this.inputValue = `${this.form.province}${this.form.city}`
    },
    selectAll(value) {
      if (value == 'province') {
        this.form.province = ''
        this.form.city = ''
        this.show = false
        this.$emit('areaForm', this.form)
      } else if (value == 'city') {
        this.form.city = ''
        this.show = false
        this.$emit('areaForm', this.form)
      }
      this.inputValue = `${this.form.province}${this.form.city}`
    },
  }
}
</script>
<style lang='less' scoped>
.citySearch {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: #fff;
  border-radius: 16px;
  .input-container {
    height: 100%;
    position: relative;
    top: 0;
    left: 0;
    cursor: pointer;
    -webkit-user-select: none;
    overflow: hidden;
    .location-icon {
      width: 25.5px;
      height: 32px;
      position: absolute;
      top: 50%;
      margin-top: -16px;
      left: 32px;
    }
    input {
      width: 600px;
      height: 100%;
      padding: 0;
      border: 0;
      outline: none;
      position: absolute;
      top: 0;
      left:  75.5px;
      font-size: 24px;
      cursor: pointer;
      &::placeholder {
        font-size: 24px;
      }
    }
    .down-icon {
      width: 22px;
      height: 22px;
      position: absolute;
      top: 50%;
      margin-top: -11px;
      right: 29.5px;
      transform: rotateZ(0deg);
      transition:  all 0.3s ease-in-out;
      &.active {
        transform: rotateZ(180deg);
      }
    }
  }
  .modal {
    width: 100%;
    position: absolute;
    margin-top: 20px;
    padding-bottom: 20px;
    background: #F5F8F4;
    border: 1px solid #B8D4B4;
    border-radius: 16px;
    .title {
      margin: 0 12px;
      height: 53.5px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      position: relative;
      -webkit-user-select: none;
      &::after {
        content: '';
        width: 700px;
        height: 1px;
        background: #CCCCCC;
        position: absolute;
        bottom: 1px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1;
      }
      span {
        width: 100px;
        height: 53.5px;
        line-height: 53.5px;
        font-size: 24px;
        font-family: FZLanTingHeiS-R-GB;
        font-weight: 400;
        color: #999999;
        position: relative;
        &.active {
          color: #4E8B46;
          font-weight: 600;
          &:after {
            content: '';
            width: 100px;
            height: 4px;
            background: #4E8B46;
            position: absolute;
            bottom: 0px;
            left: 50%;
            margin-left: -50px;
            z-index: 4;
          }
        }
      }
    }
    ::-webkit-scrollbar {
      width: 6px;
      background: #CCCCCC;
      border-radius: 50px;
    }

    ::-webkit-scrollbar-thumb {
      width: 6px;
      background: #999999;
      border-radius: 50px;
    }

    ::-webkit-scrollbar-track {
      background-color: transparent;
    }
    .content {
      margin: 0 12px;
      display: flex;
      flex-direction: row;
      ul {
        width: 50%;
        display: flex;
        flex-direction: column;
        list-style: none;
        margin: 0;
        padding: 0;
        li {
          width: 100%;
          font-size: 18px;
          font-family: FZLanTingHeiS-R-GB;
          font-weight: 400;
          color: #999999;
          margin-top: 30px;
          text-align: center;
          cursor: pointer;
          &:nth-last-of-type(1) {
            padding-bottom: 30px;
          }
          &.active {
            font-size: 24px;
            font-family: FZLanTingHeiS-DB-GB;
            font-weight: 600;
            color: #4E8B46;
          }
        }
      }
    }
  }
}
</style>